/** PM Calendar Jump — date-based message navigation. */

// ─── Calendar date-jump ─────────────────────────────────────────

window.calendarJump = {
  open: false,
  year: null,
  month: null,
  firstYear: null,
  firstMonth: null,
  activeDays: [],
  loading: false,
  /** True when the conversation is showing a historical slice (not the latest messages). */
  dateJumpActive: false,
  /** State for the current date-jump slice (oldest/newest msg IDs, has_older/has_newer). */
  _jumpState: null,
  /** Guard to prevent concurrent load-older requests triggered by scroll. */
  _loadingOlder: false,

  toggle: function() {
    if (this.open) {
      this.close();
    } else {
      this.show();
    }
  },

  show: function() {
    var threadId = window.get_active_thread_id();
    if (!threadId) return;

    // Close other menus
    $("#conversation-actions-menu").addClass("hidden");

    var now = new Date();
    this.year = now.getFullYear();
    this.month = now.getMonth() + 1;
    this.open = true;

    $("#calendar-jump-panel").removeClass("hidden");
    if (window.LucideIcons) {
      window.LucideIcons.initialize(document.getElementById('calendar-jump-panel'));
    }

    this.fetchDays(this.year, this.month);
  },

  close: function() {
    this.open = false;
    $("#calendar-jump-panel").addClass("hidden");
  },

  /** Leave the historical slice and put the newest messages at the bottom again. */
  resetDateJump: function() {
    this.dateJumpActive = false;
    this._jumpState = null;
    var c = document.getElementById('threads_right');
    if (c) c.style.flexDirection = 'column-reverse';
  },

  prevMonth: function() {
    if (this.loading) return;
    this.month--;
    if (this.month < 1) {
      this.month = 12;
      this.year--;
    }
    // Clamp to first available month
    if (this.firstYear !== null) {
      if (this.year < this.firstYear || (this.year === this.firstYear && this.month < this.firstMonth)) {
        this.year = this.firstYear;
        this.month = this.firstMonth;
        this.updateNavButtons();
        return;
      }
    }
    this.fetchDays(this.year, this.month);
  },

  nextMonth: function() {
    if (this.loading) return;
    var now = new Date();
    var nowYear = now.getFullYear();
    var nowMonth = now.getMonth() + 1;
    // Don't go beyond current month
    if (this.year > nowYear || (this.year === nowYear && this.month >= nowMonth)) return;
    this.month++;
    if (this.month > 12) {
      this.month = 1;
      this.year++;
    }
    this.fetchDays(this.year, this.month);
  },

  fetchDays: function(year, month) {
    var self = this;
    var threadId = window.get_active_thread_id();
    if (!threadId) return;

    self.loading = true;
    $("#cal-grid").empty();
    $("#cal-empty").addClass("hidden");
    $("#cal-loading").removeClass("hidden");
    self.updateMonthLabel();

    $.ajax({
      type: "POST",
      url: "/app/messages/calendar-days",
      data: {
        thread: threadId,
        year: year,
        month: month,
        has_bounds: self.firstYear !== null ? 1 : 0
      },
      dataType: "json"
    }).done(function(data) {
      self.activeDays = data.days || [];
      if (data.first_year != null) {
        self.firstYear = data.first_year;
        self.firstMonth = data.first_month;
      }
      self.renderGrid();
      self.updateNavButtons();
    }).fail(function() {
      self.activeDays = [];
      self.renderGrid();
    }).always(function() {
      self.loading = false;
      $("#cal-loading").addClass("hidden");
    });
  },

  updateMonthLabel: function() {
    var label = document.getElementById('cal-month-label');
    if (label) {
      var date = new Date(this.year, this.month - 1, 1);
      label.textContent = date.toLocaleString(document.documentElement.lang || 'en', { month: 'long', year: 'numeric' });
    }
  },

  updateNavButtons: function() {
    var prevBtn = document.getElementById('cal-prev-month');
    var nextBtn = document.getElementById('cal-next-month');
    if (!prevBtn || !nextBtn) return;

    // Disable prev if at first available month
    var atFirst = this.firstYear !== null &&
      this.year === this.firstYear && this.month === this.firstMonth;
    prevBtn.disabled = atFirst;
    prevBtn.classList.toggle('opacity-30', atFirst);
    prevBtn.classList.toggle('cursor-default', atFirst);

    // Disable next if at current month
    var now = new Date();
    var atLast = this.year === now.getFullYear() && this.month === now.getMonth() + 1;
    nextBtn.disabled = atLast;
    nextBtn.classList.toggle('opacity-30', atLast);
    nextBtn.classList.toggle('cursor-default', atLast);
  },

  renderGrid: function() {
    var grid = document.getElementById('cal-grid');
    var empty = document.getElementById('cal-empty');
    if (!grid) return;

    grid.innerHTML = '';

    // First day of month (0=Sun, 1=Mon, ... 6=Sat)
    var firstDow = new Date(this.year, this.month - 1, 1).getDay();
    // Convert to Mon=0 ... Sun=6
    var startOffset = (firstDow + 6) % 7;
    var daysInMonth = new Date(this.year, this.month, 0).getDate();
    var today = new Date();
    var isCurrentMonth = this.year === today.getFullYear() && this.month === today.getMonth() + 1;
    var todayDay = today.getDate();

    // Empty cells for offset
    for (var i = 0; i < startOffset; i++) {
      var spacer = document.createElement('div');
      spacer.className = 'h-9 w-9';
      grid.appendChild(spacer);
    }

    var hasAny = this.activeDays.length > 0;

    for (var d = 1; d <= daysInMonth; d++) {
      var cell = document.createElement('div');
      cell.className = 'relative flex items-center justify-center h-9 w-9 mx-auto';

      var isActive = this.activeDays.indexOf(d) !== -1;
      var isFuture = isCurrentMonth && d > todayDay;
      var isToday = isCurrentMonth && d === todayDay;

      if (isActive && !isFuture) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'h-8 w-8 rounded-full text-sm font-medium border-0 cursor-pointer transition-colors ' +
          (isToday ? 'text-sky-600 bg-sky-50 hover:bg-sky-100' : 'text-gray-800 hover:bg-sky-50 hover:text-sky-600 bg-transparent');
        btn.textContent = d;
        var ariaDate = new Date(this.year, this.month - 1, d);
        btn.setAttribute('aria-label', ariaDate.toLocaleDateString(document.documentElement.lang || 'en', { month: 'long', day: 'numeric', year: 'numeric' }));
        btn.dataset.day = d;
        btn.addEventListener('click', this._onDayClick.bind(this));
        cell.appendChild(btn);

        // Dot indicator
        var dot = document.createElement('span');
        dot.className = 'absolute bottom-0 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-sky-400';
        cell.appendChild(dot);
      } else {
        var span = document.createElement('span');
        span.className = 'text-sm ' + (isFuture ? 'text-gray-200' : 'text-gray-300');
        span.textContent = d;
        cell.appendChild(span);
      }

      grid.appendChild(cell);
    }

    if (empty) {
      if (!hasAny) {
        empty.classList.remove('hidden');
      } else {
        empty.classList.add('hidden');
      }
    }
  },

  _onDayClick: function(e) {
    var day = parseInt(e.currentTarget.dataset.day, 10);
    var dateStr = this.year + '-' +
      String(this.month).padStart(2, '0') + '-' +
      String(day).padStart(2, '0');
    this.close();
    this.jumpToDate(dateStr);
  },

  jumpToDate: function(dateStr) {
    var self = this;
    var threadId = window.get_active_thread_id();
    if (!threadId) return;

    // Deactivate paginated view if active
    if (window.pagedViewActive) {
      window.pagedViewActive = false;
      $("#paged-view-controls").remove();
    }
    // Runs before this request takes pm_ajax_request_active below.
    window.abandonPagedLoad?.();

    window.pm_ajax_request_active = 1;
    $.ajax({
      type: "POST",
      url: "/app/messages/jump-to-date",
      data: { thread: threadId, date: dateStr },
      dataType: "json"
    }).done(function(data) {
      if (data.error || !data.body) return;

      var c = $("#threads_right");

      // Switch to normal column direction for historical slice
      c.get(0).style.flexDirection = 'column';
      self.dateJumpActive = true;

      // Replace wrapper
      var newWrapper = $('<div id="messages_wrapper"></div>');
      newWrapper.append(data.body);
      var oldWrapper = c.find('#messages_wrapper');
      if (oldWrapper.length) {
        oldWrapper.replaceWith(newWrapper);
      } else {
        c.empty().append(newWrapper);
      }

      // Scroll to top of loaded slice
      c.get(0).scrollTop = 0;

      // Show "jump to latest" button so user can return
      var jumpBtn = document.getElementById('jump-to-latest-btn');
      if (jumpBtn) {
        // The decision bar holds the compose slot for a pending Request, and
        // a hidden compose box measures 0.
        var bottomUi = window.pm_bottom_ui ? window.pm_bottom_ui() : null;
        jumpBtn.style.bottom = (bottomUi ? bottomUi.offsetHeight + 12 : 80) + 'px';
        jumpBtn.classList.remove('hidden');
        jumpBtn.classList.add('flex');
      }

      // Store metadata for loading more in either direction
      self._jumpState = {
        hasOlder: data.has_older,
        hasNewer: data.has_newer,
        oldestMsgId: data.oldest_msg_id,
        newestMsgId: data.newest_msg_id
      };

      // Add "load newer" trigger at the bottom if there are newer messages
      if (data.has_newer && data.newest_msg_id) {
        var newerDiv = document.createElement('div');
        newerDiv.id = 'load_newer_messages';
        newerDiv.className = 'flex items-center justify-center gap-2 py-3 text-sm text-sky-500 hover:text-sky-600 cursor-pointer font-medium';
        newerDiv.innerHTML = '<i data-lucide="chevron-down" class="w-4 h-4"></i> ' +
          window.tOr('legacy.pm.load_newer_messages', 'Load newer messages');
        newerDiv.addEventListener('click', function() { self._loadNewerMessages(); });
        newWrapper.get(0).appendChild(newerDiv);
      }

      // Update header status
      if (data.contact_status) window.update_header_status(data.contact_status);
      if (data.contact_active === false) {
        $("#threads_right_bottom").addClass("hidden");
        if (data.contact_name) {
          $("#current_thread_username").text(data.contact_name);
        }
      }

      // Initialize icons and audio players
      if (window.LucideIcons) window.LucideIcons.initialize(newWrapper.get(0));
      if (window.initAudioPlayers) window.initAudioPlayers();
    }).always(function() {
      window.pm_ajax_request_active = 0;
    });
  },

  /** Load older messages above the current historical slice. */
  _loadOlderMessages: function() {
    var self = this;
    var state = this._jumpState;
    if (!state || !state.hasOlder || !state.oldestMsgId) return;
    if (this._loadingOlder) return;

    var threadId = window.get_active_thread_id();
    if (!threadId) return;

    this._loadingOlder = true;
    window.pm_ajax_request_active = 1;
    var c = document.getElementById('threads_right');
    var scrollHeightBefore = c.scrollHeight;

    $.ajax({
      type: "POST",
      url: "/app/messages/load",
      data: { thread: threadId, last_msg_id: state.oldestMsgId },
      dataType: "json"
    }).done(function(data) {
      // Every /app/messages/load response carries a fresh typing token.
      window.storeThreadTypingToken?.(threadId, data);

      // A reset or another jump after this request went out ends this slice.
      if (self._jumpState !== state) return;
      if (!data.body) return;

      var wrapper = document.getElementById('messages_wrapper');
      if (!wrapper) return;

      // Remove existing "load older" button
      var loadOlderBtn = document.getElementById('load_older_messages');
      if (loadOlderBtn) loadOlderBtn.remove();

      // Prepend older messages using a DocumentFragment to preserve order
      var temp = document.createElement('div');
      temp.innerHTML = data.body;
      var frag = document.createDocumentFragment();
      while (temp.firstChild) {
        frag.appendChild(temp.firstChild);
      }
      wrapper.insertBefore(frag, wrapper.firstChild);

      // Maintain scroll position (column direction, not column-reverse)
      var scrollHeightAfter = c.scrollHeight;
      c.scrollTop += (scrollHeightAfter - scrollHeightBefore);

      // Update state: find the new oldest message
      var firstMsg = wrapper.querySelector('.pm_msg');
      if (firstMsg) {
        state.oldestMsgId = firstMsg.id.replace('msg_', '');
      }
      state.hasOlder = !!wrapper.querySelector('#load_older_messages');

      if (window.LucideIcons) window.LucideIcons.initialize(wrapper);
      if (window.initAudioPlayers) window.initAudioPlayers();
    }).always(function() {
      window.pm_ajax_request_active = 0;
      self._loadingOlder = false;
    });
  },

  /** Load newer messages below the current historical slice. */
  _loadNewerMessages: function() {
    var self = this;
    var state = this._jumpState;
    if (!state || !state.hasNewer || !state.newestMsgId) return;

    var threadId = window.get_active_thread_id();
    if (!threadId) return;

    // Remove the "load newer" button
    var newerBtn = document.getElementById('load_newer_messages');
    if (newerBtn) newerBtn.remove();

    window.pm_ajax_request_active = 1;
    $.ajax({
      type: "POST",
      url: "/app/messages/update",
      data: {
        thread: threadId,
        newest_msg_id: state.newestMsgId
      },
      dataType: "json"
    }).done(function(data) {
      // A reset or another jump after this request went out ends this slice.
      if (self._jumpState !== state) return;
      if (!data.new_messages) return;

      var wrapper = document.getElementById('messages_wrapper');
      if (!wrapper) return;

      // Append newer messages at the bottom
      var temp = document.createElement('div');
      temp.innerHTML = data.new_messages;
      while (temp.firstChild) {
        wrapper.appendChild(temp.firstChild);
      }

      // Update state with the newest message ID
      var allMsgs = wrapper.querySelectorAll('.pm_msg');
      if (allMsgs.length) {
        var lastMsg = allMsgs[allMsgs.length - 1];
        state.newestMsgId = lastMsg.id.replace('msg_', '');
      }

      // If we got messages, there might be more — add another load button
      var hasNewContent = data.new_messages && typeof data.new_messages === 'string' && data.new_messages.trim().length > 0;
      if (hasNewContent) {
        var newerDiv = document.createElement('div');
        newerDiv.id = 'load_newer_messages';
        newerDiv.className = 'flex items-center justify-center gap-2 py-3 text-sm text-sky-500 hover:text-sky-600 cursor-pointer font-medium';
        newerDiv.innerHTML = '<i data-lucide="chevron-down" class="w-4 h-4"></i> ' +
          window.tOr('legacy.pm.load_newer_messages', 'Load newer messages');
        newerDiv.addEventListener('click', function() { self._loadNewerMessages(); });
        wrapper.appendChild(newerDiv);
        state.hasNewer = true;
      } else {
        state.hasNewer = false;
      }

      if (window.LucideIcons) window.LucideIcons.initialize(wrapper);
      if (window.initAudioPlayers) window.initAudioPlayers();
    }).always(function() {
      window.pm_ajax_request_active = 0;
    });
  },

  /** Return to the latest messages (normal chat view). */
  returnToLatest: function() {
    this.resetDateJump();

    var threadId = window.get_active_thread_id();
    if (threadId) {
      window.view_thread(threadId, true);
    }
  }
};

// Close calendar panel when clicking outside
document.addEventListener('click', function(e) {
  if (!window.calendarJump.open) return;
  var panel = document.getElementById('calendar-jump-panel');
  var btn = document.getElementById('calendar-jump-btn');
  if (panel && !panel.contains(e.target) && btn && !btn.contains(e.target)) {
    window.calendarJump.close();
  }
});

// Close calendar when switching threads
(function() {
  var origViewThread = window.view_thread;
  window.view_thread = function(thread_id, reload_messages) {
    // Without a reload, view_thread only marks the thread row active.
    if (reload_messages) {
      window.calendarJump.close();
      if (window.calendarJump.dateJumpActive) {
        window.calendarJump.resetDateJump();
      }
    }
    return origViewThread.apply(this, arguments);
  };
})();
